// Nav

const Nav = () => {
  const nav = document.querySelector('.nav');
  const navItemToggle = document.querySelectorAll('.nav__submenu-toggle');
  const navToggle = document.querySelector('.nav-toggle');
  const navOpenClass = 'nav-open';
  let lastScrollPosition = 0;

  if (!nav && !navToggle) return;

  navToggle.addEventListener('click', () => toggleNav());
  
  document.addEventListener('keyup', e => {
    if (e.key === 'Escape') {
      toggleNav(false);
    }
  });
  
  document.addEventListener('scroll', () => {
    toggleNav(false);
  });

  // Fixed header
  (function () {
    const header = document.querySelector('.header');
    const hiddenClass = 'header--hidden';
    const thresholdHidden = header.clientHeight;
    let scrollDirection = 'down';

    function toggleHiddenHeader(state) {
      header.classList.toggle(hiddenClass, state);
    }

    window.addEventListener('scroll', () => {
      const scrollDelta = (window.scrollY - lastScrollPosition);
      if (scrollDelta > 0) {
        // Scroll down
        scrollDirection = 'down';
        toggleHiddenHeader(window.scrollY > thresholdHidden);
      } else {
        // Scroll up
        scrollDirection = 'up';
        toggleHiddenHeader(false);
      }

      lastScrollPosition = window.scrollY;
    });

    toggleHiddenHeader(false);
  })();

  function toggleNav(state) {
    let method;
    if (typeof state === 'undefined') {
      method = 'toggle';
    } else {
      method = state ? 'add' : 'remove';
    }
    document.body.classList[method](navOpenClass);
  }
  
  // Language
  const currentLang = document.querySelector('.nav__menu--language > li > a');
  currentLang.addEventListener('click', e => {
    e.preventDefault();
    const toggle = e.currentTarget.parentNode.querySelector('.nav__submenu-toggle');
    toggle.click();
  });
  
  // Submenu
  navItemToggle.forEach(toggle => {
    const item = toggle.closest('li');
    // const isActive = item.classList.contains('active');
    // item.classList.toggle('expanded', isActive);
    
    toggle.addEventListener('click', e => item.classList.toggle('expanded'));
  });
}

export default Nav;
